import { inject, Injectable } from '@angular/core';
import { HttpClientService } from '@sa/app/core/services/http-client.service';
import { ApplicationUser } from '../interfaces/ApplicationUser';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { IApplicationAgent } from '../interfaces/ApplicationAgent';
import { SessionStorageService } from './session-storage.service';
import { ApplicationConstants } from '../constants/ApplicationConstants';

@Injectable({
  providedIn: 'root'
})
export class UserAgentService {

  private httpClientService = inject(HttpClientService);
  private sessionStorageService = inject(SessionStorageService);

  getApplicationUsers(tenantId: string): Observable<ApplicationUser[]> {
      return this.httpClientService.get<ApplicationUser[]>(API_ENDPOINTS.GET_APPLICATION_USERS(tenantId));
    }

  getAgents(): Observable<IApplicationAgent[]> {
      const tenantGuid = this.sessionStorageService.getItem<string>(
        ApplicationConstants.SessionKeyConstants.TenantId
      ) ?? '';
      return this.httpClientService.get<IApplicationAgent[]>(API_ENDPOINTS.GET_AGENT_LIST(tenantGuid));
    }
}
